<div class="fpx-form-control">
  <fpx-label #fpxLabel *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
  <div class="fpx-field-content">
    <input
      type="text"
      [placeholder]="placeholder"
      [(ngModel)]="searchInput"
      (input)="onInput(searchInput)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keyup)="onKeyup()"
      matInput
      [matAutocomplete]="searchableDrodpown"
      [disabled]="disable"
      #trigger="matAutocompleteTrigger"
      #fpxInput
    />

    <ng-container *ngIf="loading; else searchIcon">
      <img
        class="form-loader"
        src="./assets/svg/Spin34px.svg"
        alt="loading_svg"
      />
    </ng-container>
    <ng-template #searchIcon>
      <svg
        class="svg-icon"
        aria-labelledby="title desc"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19.9 19.7"
      >
        <title id="title">Search Icon</title>
        <desc id="desc">A magnifying glass icon.</desc>
        <g class="search-path" fill="none" stroke="#848F91">
          <path stroke-linecap="square" d="M18.5 18.3l-5.4-5.4" />
          <circle cx="8" cy="8" r="7" />
        </g>
      </svg>
    </ng-template>

    <mat-autocomplete
      #searchableDrodpown="matAutocomplete"
      (optionSelected)="onSelect($event)"
      [displayWith]="displayFn"
      class="fpx-autocomplete-panel {{ ngTemplateName }}"
      (opened)="infiniteScroll()"
    >
      <ng-container
        *ngIf="selectableList$ | async as selectableDataList; else shownodata"
      >
        <ng-container
          *ngIf="
            selectableDataList && selectableDataList.length > 0;
            else shownodata
          "
        >
          <mat-option  [disabled]="true" *ngIf="selectableDataList[0].id === -1"
            >No Data Found</mat-option
          >
          <ng-container *ngIf="selectableDataList[0].id !== -1">
            <mat-option (mousedown)="$event.preventDefault()"
            [class]="option.id === selectedId ? 'mat-selected' : ''"
              *ngFor="let option of selectableDataList"
              [value]="option"
            >
              {{ option.text }}
            </mat-option>
          </ng-container>
        </ng-container>
      </ng-container>
    </mat-autocomplete>
  </div>
  <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
    {{ errorCode }}
  </mat-error>
</div>
<ng-template #shownodata>
  <mat-option>No Data Found</mat-option>
</ng-template>
